var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 14,
    viewBox: "0 0 23 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7436 7C18.2788 7 19.5137 5.88 19.5137 4.5C19.5137 3.12 18.2788 2 16.7436 2C15.2083 2 13.9623 3.12 13.9623 4.5C13.9623 5.88 15.2083 7 16.7436 7ZM8.3998 6C10.2466 6 11.7262 4.66 11.7262 3C11.7262 1.34 10.2466 0 8.3998 0C6.55305 0 5.0623 1.34 5.0623 3C5.0623 4.66 6.55305 6 8.3998 6ZM16.7436 9C14.7077 9 10.6248 9.92 10.6248 11.75V14H22.8623V11.75C22.8623 9.92 18.7794 9 16.7436 9ZM8.3998 8C5.80768 8 0.612305 9.17 0.612305 11.5V14H8.3998V11.75C8.3998 10.9 8.76693 9.41 11.0364 8.28C10.0686 8.1 9.13405 8 8.3998 8Z",
    fill: "#323232"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.e9648f995a19dbfac96e833f0a8828c6.svg";
export { ForwardRef as ReactComponent };